const objectItems = {
  label1: 'Calendario',
  label2: 'Acciones generadas',
  label3: 'Lugares',
  label4: 'Mapa',
  label5: 'Dashboard',
  label6: 'Equipo',
  label7: 'Servicios',
  label8: 'Terceras empresas',
  label9: 'Usuários',
  label10: 'Departamentos',
  label11: 'Tipos de Equipos',
  label12: 'Grupos',
  label13: 'Periodicidades',
  label14: 'Tipos de Servicios',
  label15: 'Mi Cuenta',
  label16: 'Archivos de soporte',
  label17: 'Backups (App)',
  label19: 'Mantenimientos',
  label18: 'Informes',
  label20: 'Servicios Vencidos',
  label21: 'Servicios Programados',
  label22: 'Calendario de Servicios Programados',
  label23: 'Ajustes',
  label24: 'Datos Descargados',
  serviceDrafts: 'Rascunhos de Servicio',
}

export default objectItems;
